import { useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"
import { useApi } from "../../../hooks/useApi"

const useTradingSectors = () => {
  const { scientApi } = useApi()

  const { data, error, isLoading } = useQuery(
    ["trading_sectors"],
    scientApi.trading.getTradingSectors,
    {
      retry: 1,
      staleTime: Infinity, // Static list, no need to refresh.
    },
  )

  return {
    sectors: data,
    error: error as AxiosError,
    isLoading,
  }
}

export default useTradingSectors
